import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Divider } from "primereact/divider";
import { Accordion, AccordionTab } from 'primereact/accordion';

export default function ({ application, form }) {

    console.log(application.correction !==""

    )
    return (
        <>
            <Accordion className="mt-5" activeIndex={0}>

                <AccordionTab header={ application.correction ==="" ? "Correction Reason " :"Referral Reason"}>
                    <div style={{ borderRadius: 0 }}>
                        {/* <h4>Referral Reason</h4> */}
                       { application?.referralReasons !=" " && <>
                        {(application?.referralReasons || []).map(e => <div>
                            <h6>{e.referralReason}</h6>
                            <p>{e.notes}</p>
                            <hr />
                        </div>)}
                        <br />
                       </>
}
{ application?.applicationCorrectionModels. length > 0 && <>
                        {(application?.applicationCorrectionModels || []).map(e => <div>
                            <h6>{e.correctionAttributesModel?.name }</h6>
                            <p>{e.correctionNote}</p>
                            <hr />
                        </div>)}
                        <br />
                       </>
}
                       
                    </div>
                </AccordionTab>


            </Accordion>

        </>

    );
}
